import {
    CLEAR_QUEUE,
    FETCH_QUEUE,
    FETCH_GROUP_QUEUE_DETAIL,
    LIST_QUEUE,
    LOCK_GROUPED_QUEUE_DRAW,
    CHECK_GROUPED_QUEUE
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    filterDetail: {},
    data: [],
    summary: {},
    activeQueue: null,
    pagination: {
        page: 0,
        totals: 0,
        size: 20
    }
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_QUEUE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
            case FETCH_GROUP_QUEUE_DETAIL:
            return {
                ...state,
                filterDetail: payload,
            };
        case LIST_QUEUE:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
                summary: payload.summary || {},
                pagination: {
                    ...payload.paging
                }
            };
        case LOCK_GROUPED_QUEUE_DRAW:
            return {
                ...state,
                data: Array.isArray(state.data)
                    ? state.data.map((row) => ({
                        ...row,
                        draws: Array.isArray(row?.draws)
                            ? row.draws.map((draw) => {
                                const drawKey = draw?.key ?? draw?.id ?? draw?.shiftCode;
                                if (`${drawKey}` !== `${payload?.drawKey}`) {
                                    return draw;
                                }

                                return {
                                    ...draw,
                                    lockedCount: draw?.count || 0
                                };
                            })
                            : row?.draws
                    }))
                    : state.data
            };
        case CHECK_GROUPED_QUEUE:
            return {
                ...state,
                data: Array.isArray(state.data)
                    ? state.data.map((row) => {
                        const allDrawKey = row?.draws?.find((d) => d?.shiftCode === "ALL")?.key || row?.draws?.[0]?.key || row?.key;
                        const isMatchRow = `${allDrawKey}` === `${payload?.key}` || `${row?.key}` === `${payload?.key}` || row?.draws?.some((d) => `${d?.key}` === `${payload?.key}`);
                        if (!isMatchRow) return row;

                        const isChecked = payload.isChecked;
                        const isAllMatch = `${allDrawKey}` === `${payload?.key}` || `${row?.key}` === `${payload?.key}`;

                        return {
                            ...row,
                            ...(isAllMatch ? {
                                isChecked,
                                checkedByUsername: payload.checkedByUsername,
                                checkedAt: payload.checkedAt,
                                hasNewPapers: payload.hasNewPapers
                            } : {}),
                            draws: Array.isArray(row?.draws)
                                ? row.draws.map((draw) => {
                                    const drawKey = draw?.key ?? draw?.id ?? draw?.shiftCode;
                                    if (`${drawKey}` === `${payload?.key}` || (isAllMatch && draw?.shiftCode === "ALL")) {
                                        return {
                                            ...draw,
                                            isChecked,
                                            checkedByUsername: payload.checkedByUsername,
                                            checkedAt: payload.checkedAt,
                                            hasNewPapers: payload.hasNewPapers
                                        };
                                    }
                                    return draw;
                                })
                                : row?.draws
                        };
                    })
                    : state.data
            };
        case CLEAR_QUEUE:
            return {
                ...state,
                ...init
            };
        default:
            return state;
    }
}
